export default __webpack_public_path__ + "static/card-example1-cda4d0159f8a9cd84bc4f946ce2e6a46.png";